import mitt from 'mitt';
const eventBusMitter = mitt();
export default eventBusMitter;
